export interface IRecipientProfileRecords {
    isVoucher: boolean,
    isRemoteDirect: boolean,
    aboUploadPath: string
    aboUploadDate: string
    demographicsUploadPath: string
    demographicsUploadDate: string
    histogeneticsPdfTypingFile: string
    histogeneticsPdfTypingUploadDate: string
    histogeneticsPdfAboFile: string,
    histogeneticsPdfAboUploadDate: string,
    adpFormFilePath: string
}